import { Controller } from '@hotwired/stimulus';
import { patch } from '@rails/request.js';

export default class extends Controller {
  static targets = ['notice', 'progressBar'];

  connect() {
    this.boundSetDaysElapsedPosition = this.setDaysElapsedPosition.bind(this);
    this.setDaysElapsedPosition();
    window.addEventListener('resize', this.boundSetDaysElapsedPosition);
  }

  disconnect() {
    window.removeEventListener('resize', this.boundSetDaysElapsedPosition);
  }

  async markNoticeAsRead(event) {
    event.preventDefault();
    const markNoticeAsReadPath = this.data.get('markNoticeAsReadPath');
    if (!markNoticeAsReadPath) return null;

    const response = await patch(markNoticeAsReadPath);
    if (response.ok) {
      this.noticeTarget.hidden = true;
    }
  }

  setDaysElapsedPosition() {
    let root = document.documentElement;
    root.style.setProperty(
      '--progress-bar-width',
      this.progressBarTarget.offsetWidth + 'px'
    );
  }
}
